import { jwpPlayerId } from '../constants';
import domWrap from '../utils/domWrap';
import h from '../utils/htm';
import http from '../utils/http';
import playerTrack from '../utils/playerTrack';

let activeModalPlayer;

export default async body => { // 'body'
	
	domWrap(body).on('click','comp-card[video] > comp-background, comp-card[video] > h3',async function(){
		const 	{default: jwp} = await import('../libs/jwplayerMod'),
				{default: lightbox} = await import('../utils/lightbox'),
				container = this.closest('comp-card[video]'),
				jwpid = container.getAttribute('video'),
				href = container.getAttribute('href') || '';

		lightbox(
			h('div class="vid-holder"',
				h('div')(href ? 'span actions' : '',
					h('a href="'+href+'" target="_blank" class="download" download','Download')
					('a href="mailto:?subject=Freightliner Video&body=Video URL: '+ encodeURIComponent('https://'+href.split('//').pop())+'" class="email" target="mailto-target" email','Email')
				)
				('iframe name="mailto-target"')
			),() => {
				activeModalPlayer = jwp(document.querySelector('#modal-lightbox .vid-holder > div'));
				http('https://content.jwplatform.com/feeds/' + jwpid + '.json').get()
					.then(data => {
						activeModalPlayer.setup({
							width: 560,
							height: 315,
							autostart: true,
							pid:jwpPlayerId,
							playlist: data.playlist
						});
						playerTrack(activeModalPlayer);
					})
					.catch(()=>{});
			},() => {
				try{
					activeModalPlayer.remove();
				} catch(e) {}
			});
		
	});
};